import { t } from '../../../essentials/i18n';
import type { IntentInstallStore } from './IntentInstallStore';

export const MULTIPLE_APPS_TRANSLATION = {
  header: 'PLATFORM_Progress_Bar_Silent_Install_Multi_Apps_FirstStep',
  headerAfterFetch: 'PLATFORM_Progress_Bar_Silent_Install_Multi_Apps_Header',
  stepPrefix: `PLATFORM_Progress_Bar_Silent_Install_Multi_Apps_Text`, // 2 is max
  lastStep: 'PLATFORM_Progress_Bar_Silent_Install_Multi_Apps_Text3',
};

export const SINGLE_APP_TRANSLATION = {
  header: 'PLATFORM_Progress_Bar_Silent_Install_Single_Apps_FirstStep',
  headerAfterFetch: 'Installation_Popup_Loader_Header',
  stepPrefix: 'Installation_Popup_Loader_Text', // 4 is max
  lastStep: 'Installation_Popup_Loader_Text5',
};

type TranslationKey =
  | keyof typeof MULTIPLE_APPS_TRANSLATION
  | keyof typeof SINGLE_APP_TRANSLATION;

type TranslationOptions = {
  params?: object;
  transformKey?: (key: string) => string;
};

const defaultTransformKey = (key: string) => key;

export const getTranslation = (
  intentInstallStore: IntentInstallStore,
  key: TranslationKey,
  options?: TranslationOptions,
) => {
  const translationParams = options?.params || {};
  const transformKey = options?.transformKey || defaultTransformKey;

  const translations = intentInstallStore.getIsSingleApp()
    ? SINGLE_APP_TRANSLATION
    : MULTIPLE_APPS_TRANSLATION;

  const transformedKey = transformKey(translations[key]);

  return t(transformedKey, transformedKey, translationParams);
};
